export default "__VITE_ASSET__D3x2Py3W__"